<template>
	<div>
		<el-table stripe :data="tableData" size="small" style="width: 100%;margin-bottom: 20px; color: #000;" border
			@selection-change="handleSelectionChange" @sort-change="changeTableSort">
			<el-table-column type="selection" width="55" v-if="multSelect">
			</el-table-column>

			<el-table-column prop="stu_name" label="姓名" width="100">
				<template slot-scope="scope">
					<span style="cursor: pointer; color: #007AFF;" v-if="!$store.state.exprise"
						@click="stuid = scope.row.id; showStuMore = true;">{{ scope.row.stu_name }}</span>
					<span style="cursor: pointer; color: #007AFF;" v-else>{{ scope.row.stu_name }}</span>
				</template>
			</el-table-column>

			<el-table-column prop="exam_num" label="准考证号" width="120"></el-table-column>
			<el-table-column prop="exam_score" label="总分" width="80" sortable="custom"></el-table-column>

			<el-table-column prop="gender" label="性别" width="80" sortable="custom">
				<template slot-scope="scope">

					<span v-if="scope.row.gender == 1">男</span>
					<span v-if="scope.row.gender == 2">女</span>

					<span v-if="scope.row.gender == 0">未知</span>
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="备注" width="150"></el-table-column>
		
			<el-table-column prop="yuanxi_name" label="系部" width="120"></el-table-column>
			<el-table-column prop="major_name" label="专业名称" min-width="140"></el-table-column>
			<el-table-column prop="major_code" label="专业代码" width="100"></el-table-column>
			<el-table-column prop="xuezhi" label="学制" width="100"></el-table-column>



			<el-table-column v-if="!$store.state.exprise" prop="phone" label="联系方式" min-width="120"></el-table-column>
			<el-table-column prop="flag" label="自主报名" width="90">
				<template slot-scope="scope">
					<span v-if="scope.row.ctype == 0" style="color: green;">是</span>
					<span v-else style="color: blue;">否</span>
				</template>
			</el-table-column>
			<el-table-column prop="flag" label="班级" width="150">
				<template slot-scope="scope">
					{{scope.row.major_name +"/"+ scope.row.class_name}}
				</template>
			</el-table-column>
			
			<el-table-column prop="status" label="状态" width="80">
				<template slot-scope="scope">

					<div>
						<span v-if="scope.row.status == 1" style="color: green;">已审核</span>
						<span v-if="scope.row.status == 2" style="color: blue;">已审核</span>
						<span v-if="scope.row.status == 3" style="color: deepskyblue;">已录取</span>
						<span v-if="scope.row.status == 4" style="color: #096DD9;">已分班</span>
						<span v-if="scope.row.status == -1" style="color: orangered;">不通过</span>
						<span v-if="scope.row.status == -2" style="color: orangered;">已退档</span>
						<span v-if="scope.row.status == -6" style="color: orangered;">已退学</span>
						<span v-if="scope.row.status == 0" style="color: gray;">未审核</span>
					</div>
				</template>
			</el-table-column>

			<el-table-column v-if="!$store.state.exprise" prop="username" label="录入员" width="100"></el-table-column>
			<el-table-column v-if="!$store.state.exprise" prop="cdate" label="录入时间" width="150"></el-table-column>



			<el-table-column v-if="!$store.state.exprise" fixed="right" label="操作" width="200">
				<template slot-scope="scope">
					<!-- <el-popconfirm width="200" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info" iconColor="red"
					 @confirm="handleDel(scope.row)" placement="left" title="是否确定删除？">
						<a slot="reference" size="small" style="color: red;font-size: 12px;margin-right: 10px;">删除</a>
					</el-popconfirm> -->
					<el-button @click="handleModify(scope.row, 0)" v-if="scope.row.status < 3&&scope.row.status >-2" type="text" size="small">
						录取确认</el-button>
					<el-button @click="handleModify(scope.row, 1)" type="text" size="small">查看</el-button>

					
					<el-button  type="text" size="small" v-if="scope.row.status <= 4&&scope.row.status >-2" @click="showPrintDialog(scope.row)">录取通知书</el-button>
				
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize"
			:total="page.total" @size-change="handleSizeChange" :page-sizes="page.pageSizes"
			layout="total, prev, pager, next, sizes, jumper">
		</el-pagination>
		<luPrint v-if="showPrint" :stuid="stuid"></luPrint>
		<luLyPrint v-if="showLyPrint" :stuid="stuid"></luLyPrint>
		<BMPrint v-if="showPrintBM" :stuid="stuid"></BMPrint>
		<stuMore v-if="showStuMore" :stuid="stuid" :updmajor="true" :readonly="true"></stuMore>
		<chengnuo v-if="showPrintCN" :stuid="stuid"></chengnuo>
	</div>
</template>
<script>
import luPrint from "../components/luPrint.vue"
import BMPrint from "../components/BMPrint.vue"
import chengnuo from "../components/chengnuoPrint.vue"
import stuMore from "../components/stuMore.vue"

export default {
	name: 'Table',
	components: {
		luPrint,
		BMPrint,
		stuMore,
		chengnuo,
	},
	data() {
		return {
			stuid: 0,
			showPrint: false,
			showLyPrint: false,
			showPrintBM: false,
			showStuMore: false,
			showPrintCN: false
		}
	},
	props: {
		page: {
			type: Object,
		},
		tableData: {
			type: Array,
			default: []
		},
		from: {
			type: String,
			default: ''
		},
		multSelect: {
			type: Boolean,
			default: true
		},
	},
	methods: {
		viewPrintBM(stu) {
			this.stuid = stu.id
			this.showPrintBM = true
		},
		viewPrintCN(stu) {
			this.stuid = stu.id
			this.showPrintCN = true
		},

		closeBM() {
			this.showPrintBM = false
		},
		handleModify(row, t) {
			row.t = t
			this.$emit('handleModify', row)
		},
		handleDel(row) {
			this.$emit('handleDel', row)
		},
		handleSelectionChange(val) {
			this.$emit('handleSelectionChange', val)
		},
		changeTableSort(column) {
			this.$emit('changeTableSort', column)

		},
		handlePageChange(e) {
			this.$emit('handlePageChange', e)
		},
		handleSizeChange(e) {
			this.$emit('handleSizeChange', e)
		},
		showPrintDialog(e) {
			this.stuid = e.id
			this.showPrint = true
		},
		showLyPrintDialog(e) {
			this.stuid = e.id
			this.showLyPrint = true
		},
		closePrint() {
			this.showPrint = false
		},
		refreshList(e) {
			this.$emit('refreshList', e)
		}
		
	}
}
</script>
